export default __webpack_public_path__ + "static/media/logo.d37fcd21.svg";